<script setup lang="ts">
  import { IconImage } from '@/shared/ui';
  import type { CellContentAlignment } from '../../../../../model/form.types';
  import { ALIGNMENT_OPTIONS } from '../../../../../lib/cell-alignment';

  interface Props {
    modelValue: CellContentAlignment;
  }

  defineProps<Props>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: CellContentAlignment): void;
  }>();
</script>

<template>
  <div class="alignment-picker flex flex-col gap-1 min-w-[44px]">
    <button
      v-for="option in ALIGNMENT_OPTIONS"
      :key="option.value"
      v-tippy="{
        content: option.label,
        placement: 'right',
        theme: 'custom',
        trigger: 'mouseenter',
        hideOnClick: true,
      }"
      type="button"
      :class="[
        'alignment-btn flex items-center justify-center rounded p-1.5 transition-colors [&_svg]:h-5 [&_svg]:w-5 [&_svg]:shrink-0 [&_svg]:overflow-visible',
        modelValue === option.value
          ? 'bg-[var(--theme-secondary-tint)] text-[var(--theme-secondary-ink)]'
          : 'text-gray-03 hover:bg-[var(--color-gray-01)]',
      ]"
      :aria-label="option.label"
      :aria-pressed="modelValue === option.value"
      @click="emit('update:modelValue', option.value)"
    >
      <IconImage
        :src="option.icon"
        :alt="option.label"
      />
    </button>
  </div>
</template>
